import Error from "@/views/404";
import CabinetIndex from '@/views/cabinet/cabinet/index';
import CabinetProfile from "@/views/cabinet/cabinet/cabinetProfile";

import CurrentLoan from '@/views/cabinet/cabinet/currentLoan';
import LoanHistory from '@/views/cabinet/cabinet/loanHistory';

export const cabinet = [
    {
        path: 'details',
        name: 'CabinetIndex',
        component: CabinetIndex,
        meta: { requireAuth: true},
    },
    {
        path: 'current-loan',
        name: 'CurrentLoan',
        component: CurrentLoan,
        meta: {requireAuth: true},
    },
    {
        path: 'loan-history',
        name: 'LoanHistory',
        component: LoanHistory,
        meta: { requireAuth: true},
    }
];